import React, { Component } from 'react';
import Lander from './DestiLander';
import Section from './Section';
import '../css/style.css.scss';
import { segmentTrackEvent } from '../utils.js';

class Destination extends Component {
	constructor() {
		super();
		this.state = {
			showSection: false,
			sectionIndex: null,
		};
		this.handleClick = this.handleClick.bind(this);
	}

	handleClick(i, toggle) {
		this.setState({sectionIndex: i});
		if (toggle) {
			this.setState({showSection: !this.state.showSection});
		} 
		window.scrollTo(0,0);
	}

	render() {
		// the shape of the destructured this.props object will match the shape of the object in destination-data.js
		const { id, lander, sections, isMobile } = this.props;

		const renderedSectionHeads = sections.map((section, i) => {
			const sectionClass = `section-hed-container ${section.season}-hed`;
			const sectionTracker = {
			      module: 'Destination',
			      category: 'open-section',
			      linkType: 'open-section',
			      label: `open-${section.season}-from-lander`,
			    };
			return (
				<div className={sectionClass} key={i}>
					<h4 className="section-season">{section.season}</h4>
					<h2 className="section-hed" dangerouslySetInnerHTML={{ __html: section.hed}} onClick={() => {segmentTrackEvent("article_clicked", sectionTracker); this.handleClick(i, true)}}></h2>
					<div className={`section-button plus section-${i}`} onClick={() => {segmentTrackEvent("article_clicked", sectionTracker); this.handleClick(i, true)}}></div>
                </div>
			)
		})

		const renderedSections = sections.map((section, i) => {
			return (
				<Section key={i} section={section} key={i} sectionIndex={i} season={section.season} handleClick={this.handleClick} isMobile={isMobile} />
			)
		})

		return (
			<div id={id}>
				{this.state.showSection 
				? 
				renderedSections[this.state.sectionIndex]
				: 
				<div>
				<Lander {...lander} isMobile={isMobile}/>
				{renderedSectionHeads}
				</div>
				}
			</div>
		);
	}
};

export default Destination;